import { useEffect } from 'react';

/**
 * Manager for chip notifications that replaces the old FloatingNotificationManager
 * Provides global function to trigger chip animations on metric cards
 */
const ChipNotificationManager = () => {
  
  useEffect(() => {
    console.log('🎯 [ChipNotificationManager] Setting up global chip notification system');
    
    // Replace the old window.showFloatingNotification with chip animation system
    window.showFloatingNotification = (type, value = 1, options = {}) => {
      const { targetWidget } = options;
      
      console.log('🎯 [ChipNotificationManager] Chip animation requested:', { type, value, targetWidget });
      
      if (!targetWidget) {
        console.warn('🎯 [ChipNotificationManager] No targetWidget specified, skipping animation');
        return;
      }
      
      // Map old widget IDs to new widget IDs (both manager and investor)
      const widgetIdMap = {
        // Manager widgets
        'watchlist-widget': 'watchlists-widget',
        'views-widget': 'views-widget', 
        'messages-widget': 'enquiries-widget',
        'documents-widget': 'documents-widget',
        'downloads-widget': 'document_downloads-widget',
        
        // Investor widgets (direct mapping)
        'new_opportunities-widget': 'new_opportunities-widget',
        'documents_uploaded-widget': 'documents_uploaded-widget', 
        'closing_soon-widget': 'closing_soon-widget',
        'watchlist_activity-widget': 'watchlist_activity-widget',
        'portfolio_summary-widget': 'portfolio_summary-widget'
      };
      
      const newWidgetId = widgetIdMap[targetWidget] || targetWidget;
      
      if (window.metricCardRegistry && window.metricCardRegistry[newWidgetId]) {
        console.log(`🎯 [ChipNotificationManager] Triggering animation on ${newWidgetId}`);
        window.metricCardRegistry[newWidgetId](type, value);
      } else {
        console.warn(`🎯 [ChipNotificationManager] No metric card registered for widget: ${newWidgetId}`);
        console.log('🎯 [ChipNotificationManager] Available widgets:', Object.keys(window.metricCardRegistry || {}));
      }
    };
    
    // Test function for debugging
    window.testChipNotification = () => {
      console.log('🧪 [ChipNotificationManager] Test function called');
      if (window.showFloatingNotification) {
        console.log('🧪 Testing watchlist widget...');
        window.showFloatingNotification('add', 1, {
          targetWidget: 'watchlists-widget'
        });
        setTimeout(() => {
          window.showFloatingNotification('remove', 1, {
            targetWidget: 'watchlists-widget'
          });
        }, 2000);
      }
    };
    
    console.log('🎯 [ChipNotificationManager] Global functions set:', {
      showFloatingNotification: !!window.showFloatingNotification,
      testChipNotification: !!window.testChipNotification,
      metricCardRegistry: !!window.metricCardRegistry
    });
    
    return () => {
      console.log('🎯 [ChipNotificationManager] Cleaning up global functions');
      delete window.showFloatingNotification;
      delete window.testChipNotification;
    };
  }, []);

  // This component doesn't render anything - it just sets up global functions
  return null;
};

export default ChipNotificationManager; 
